// Chatwoot v4.17.1 registers this module from dashboard.routes.js.
// The Community Lilith overlay deliberately reuses that registered route slot
// while exporting only Lilith-owned routes and importing no Captain runtime.
import { frontendURL } from '../../../helper/URLHelper';
import LilithWorkspace from '../lilith/LilithWorkspace.vue';
import LilithEffectRecovery from '../lilith/LilithEffectRecovery.vue';
import { LILITH_SURFACES } from '../lilith/lilithSurfaces';

const meta = {
  permissions: ['administrator', 'agent'],
};

const surfaceFromQuery = route =>
  LILITH_SURFACES.find(surface => surface.key === route.query.surface)?.key ||
  'overview';

const surfaceRoutes = LILITH_SURFACES.map(surface => ({
  path: frontendURL(`accounts/:accountId/lilith/:assistantId/${surface.key}`),
  component: LilithWorkspace,
  name: surface.routeName,
  props: route => ({
    surface: surface.key,
    assistantId: route.params.assistantId,
  }),
  meta: {
    ...meta,
    ...(surface.featureFlag ? { featureFlag: surface.featureFlag } : {}),
  },
}));

export const routes = [
  {
    path: frontendURL('accounts/:accountId/lilith/action_recovery'),
    component: LilithEffectRecovery,
    name: 'lilith_effect_recovery',
    meta: { permissions: ['administrator'] },
  },
  {
    path: frontendURL('accounts/:accountId/lilith'),
    component: LilithWorkspace,
    name: 'lilith_assistants',
    props: route => ({ surface: surfaceFromQuery(route) }),
    meta,
  },
  ...surfaceRoutes,
];
